import React, { Component } from 'react'
import PropTypes from 'prop-types'

class RiderTableSharingModal extends Component {
  copyToClipboard() {
    var textField = document.createElement('textarea')
    textField.innerText = this.props.url
    document.body.appendChild(textField)
    textField.select()
    document.execCommand('copy')
    textField.remove()
  }

  render() {
    return (
      <div className="modal-content">
        <div className="modal-inner">
          <ul className="group">
            <li>
              <span className="unit" data-title="Your shareable URL:">
                <input
                  id="copy-url"
                  type="text"
                  value={this.props.url}
                  disabled />
              </span>
            </li>
          </ul>

          <button onClick={() => {
            this.copyToClipboard()
            this.props.setModal(false)
          }}>Copy this URL</button>
        </div>
      </div>
    )
  }
}

RiderTableSharingModal.propTypes = {
  setModal: PropTypes.func
}

RiderTableSharingModal.defaultProps = {
  setModal: function() {}
}

export default RiderTableSharingModal



// WEBPACK FOOTER //
// ./src/components/modals/rider-table-sharing-modal.js